import React, { Component } from 'react';
import '../../css/match-teams.css';
import classNames from 'classnames';

class MatchTeams extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.getIsOpenState(),
        };
        this.order = ["Goalkeeper", "Defender", "Midfielder", "Attacker"];
    }

    getIsOpenState() {
        // Retrieve the object from storage
        let isOpen = true;
        try {
            isOpen = JSON.parse(localStorage.getItem('settings')).matchPage.isOpenTeams
        } catch (error) { }
        return isOpen;
    }

    setIsOpenState(newState) {
        // Retrieve the object from storage
        let storedState = JSON.parse(localStorage.getItem('settings'));
        storedState = {
            ...storedState,
            matchPage: {
                ...storedState.matchPage,
                isOpenTeams: newState,
            }
        }
        // Put the object into storage
        localStorage.setItem('settings', JSON.stringify(storedState));
    }

    toggleMenu() {
        const newState = !this.state.open;
        this.setIsOpenState(newState);
        this.setState({
            open: newState
        })
    }

    printEventsTeams(teamArray, teamId, align) {
        return (
            teamArray
                .sort((a, b) => {
                    return this.order.indexOf(a.person_position) - this.order.indexOf(b.person_position)
                })
                .map((event, index) => {
                    const allowedCodes = ['L'];
                    const shouldPrint = (
                        allowedCodes.includes(event.code)
                        && event.team_id.toString() === teamId.toString()
                    );
                    let position = "";
                    try {
                        position = event.person_position.substring(0, 1);
                    } catch (error) { }
                    return (
                        (shouldPrint) && (
                            <span key={index} className={align}>
                                <p className="position">{position}</p>
                                &nbsp;
                            <p className="number">{event.shirtnumber}</p>
                                &nbsp;
                            <p className="person">{event.person}</p>
                            </span>
                        )
                    )
                })
        )
    }

    printEventsTeamSubs(teamArray, teamId, align) {
        return (
            teamArray
                .sort((a, b) => {
                    return this.order.indexOf(a.person_position) - this.order.indexOf(b.person_position)
                })
                .map((event, index) => {
                    const allowedCodes = ['SUB'];
                    const shouldPrint = (
                        allowedCodes.includes(event.code)
                        && event.team_id.toString() === teamId.toString()
                    );
                    let position = "";
                    try {
                        position = event.person_position.substring(0, 1);
                    } catch (error) { }
                    return (
                        (shouldPrint) && (
                            <span key={index} className={align}>
                                <p className="position">{position}</p>
                                <p className="number">{event.shirtnumber}</p>
                                <p className="person">{event.person}</p>
                            </span>
                        )
                    )
                })
        )
    }

    render() {
        return (

            <div className="match-team">
                <div className="title-team" onClick={() => this.toggleMenu()}>
                <div className="icons">
                        <span className="ball">
                            <img src="/img/teams.svg" alt="" width="20" />
                        </span>
                        <h2>Equipas</h2>
                        </div>
                    <img className={classNames(this.state.open && "rotate-icon")} src="/img/arrow.svg" alt="arrow" width="20" />
                </div>
                <div className={classNames("div-lineup", !this.state.open && 'd-none')}>
                    <div className="stat-team">
                        <span>
                            <p colSpan="7">Equipa</p>
                        </span>
                    </div>
                    <div className="stat-half-padding">
                        <div className="home-lineup">
                            <div className="home-formation">
                                <span className="home-formation">
                                    {
                                        this.props.data.team_A_formation !== '0-0-0' &&
                                        this.props.data.team_A_formation
                                    }
                                </span>
                            </div>
                            <span className="lineup-a">
                                {this.printEventsTeams(this.props.data.events, this.props.data.team_A_id, 'left')}
                            </span>
                            <span className="coach-home">
                                {
                                    this.props.data.team_A_coach.map((each, index) => {
                                        if (each.name !== null) {
                                            return (
                                                <p key={index} >
                                                    Treinador:&nbsp;{each.person_name}
                                                </p>
                                            )
                                        } else {
                                            return null
                                        }
                                    })
                                }

                            </span>
                        </div>
                        <div className="away-lineup">
                            <div className="away-formation">
                                <span className="away-formation">
                                    {
                                        this.props.data.team_B_formation !== '0-0-0' &&
                                        this.props.data.team_B_formation
                                    }
                                </span>
                            </div>
                            <span className="lineup-b">
                                {this.printEventsTeams(this.props.data.events, this.props.data.team_B_id, 'right')}
                            </span>
                            <span className="coach-away">
                                {
                                    this.props.data.team_B_coach.map((each, index) => {
                                        if (each.name !== null) {
                                            return (
                                                <p key={index} >
                                                    Treinador:&nbsp;{each.person_name}
                                                </p>
                                            )
                                        } else {
                                            return null
                                        }
                                    })
                                }

                            </span>
                        </div>
                    </div>
                </div>
                <div className={classNames("div-subs", !this.state.open && 'd-none')}>
                    <div className="stat-subs">
                        <span>
                            <p colSpan="7">Suplentes</p>
                        </span>
                    </div>
                    <div className="stat-half-padding2">
                        <div className="home-subs">
                            {this.printEventsTeamSubs(this.props.data.events, this.props.data.team_A_id, 'left')}
                        </div>
                        <div className="away-subs">
                            {this.printEventsTeamSubs(this.props.data.events, this.props.data.team_B_id, 'right')}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default MatchTeams;